import axios from "axios"

const apiInstance = axios.create({
    baseURL: "https://milanday-api.kglame.com",
    // baseURL: "http://localhost:5000"
});

export default apiInstance
